
import Storage from 'utils/Storage';
import Tools from 'utils/Tools';
import store from 'redux/store';

const EMPLOYEEINFO = Storage.get('EMPLOYEEINFO', 0);
console.log(EMPLOYEEINFO);
const isMobile = Tools.isMobile();
console.log('store', store.getState());
export const sendEvent = (eventId, eventParam) => {
  window.ZM_JSSDK && window.ZM_JSSDK.sendEvent({
    eventId,
    eventParam: JSON.stringify({ ...eventParam, employeeid: EMPLOYEEINFO && EMPLOYEEINFO.employeeId, userName: EMPLOYEEINFO && EMPLOYEEINFO.userName, isClassLeader: EMPLOYEEINFO && EMPLOYEEINFO.isClassLeader, source: isMobile ? '移动端' : 'PC端' }),
    userId: EMPLOYEEINFO.employeeId
  });
}